<template>
  <div>
    <Modal v-model="isShow" width="800" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">sug联想词设置</h3>
      <Row  class="row" :gutter=16>
        <Col span="10"><span style="color: #ed4014;">*</span>sug联想词</Col>
        <Col span="10"><span style="color: #ed4014;">*</span>联想词全拼</Col>
        <Col span="4"><span style="color: #ed4014;">*</span>联想词简拼</Col>
      </Row>
      <Row class="row" :gutter=16>
        <Col span="10">
          <Input v-model="sugWord" />
        </Col>
        <Col span="10">
          <Input v-model="fullSpell"/>
        </Col>
        <Col span="4">
          <Input v-model="simpleSpell"/>
        </Col>
      </Row>
    </Modal>
  </div>
</template>

<script>
  import {labellist,labeledit} from "../../../../api/projectConfig";

  export default {
    name: "sug",
    components:{
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      projectFid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.sugWord = this.fullSpell = this.simpleSpell = ''
        this.labellist()
        this.isShow=true
        this.data = [{
          "fid": "",
          "labelName": "",
          "labelType": 10
        }]
      },
    },
    data(){
      return {
        isShow: false,
        loading: true,
        sugWord: '',
        fullSpell: '',
        simpleSpell: '',
        data:[{
          "fid": "",
          "labelName": "",
          "labelType": 10
        }]
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      labellist(){
        if(!this.fid){
          return
        }
        let params={
          moduleFid:this.fid,
          type:10
        }
        labellist(params).then(res=>{
          let list = res.data
          if(list.length){

            let entity = list[0]
            this.data[0].fid = entity.fid

            let name = entity.labelName.split('_')
            this.sugWord = name[0]
            this.fullSpell = name[1]
            this.simpleSpell = name[2]
          }
        })
      },
      ok(){

        if(!this.sugWord || !this.fullSpell || !this.simpleSpell){
          this.changeLoading()
          this.$Message.info('请检查必填项')
          return
        }

        this.data[0].labelName = this.sugWord+'_'+this.fullSpell+'_'+this.simpleSpell
        let params={
          moduleFid: this.fid,
          labelEntities: this.data,
          proHouseTypeFid: this.projectFid,
          type:1
        }
        labeledit(params).then(res=>{
          this.$Message.success('sug联想词保存成功')
          this.changeLoading()
          this.isShow = false
        }).catch(error=>{})
      },

    },
    created(){
    }
  }
</script>
<style scoped>

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }
</style>
